import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {UserService} from "../services/user.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private user: UserService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status == 401) {
                // auto logout if 401 response returned from api
                this.user.logout();
                //location.reload();
            }
            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}
